<template>
  <div>
    <b-row>
      <b-col>
        <vs-card v-if="museriDetayValidate == true">
          <b-row>
            <b-col sm="12" xl="6" class="mb-1">
              <b-row>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group label="Müşteri Ad/Soyad" label-for="basicInput">
                    <b-row>
                      <b-col style="padding-right: 0px">
                        <b-form-input
                          id="basicInput"
                          v-model="musteriAdSoyad"
                        />
                      </b-col>
                      <b-col style="padding-left: 0px">
                        <b-form-input id="basicInput" v-model="musteriSoyad" />
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group label="Telefon/GSM" label-for="basicInput">
                    <b-row>
                      <b-col style="padding-right: 0px"
                        ><b-form-input id="basicInput" v-model="musteriTelefon"
                      /></b-col>
                      <b-col style="padding-left: 0px"
                        ><b-form-input id="basicInput" v-model="musteriGSM"
                      /></b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group label="E-Mail" label-for="basicInput">
                    <b-form-input id="basicInput" v-model="musteriMail" />
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group label="Adres" label-for="basicInput">
                    <b-form-input id="basicInput" v-model="musteriAdres" />
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group label="Ülke" label-for="basicInput">
                    <b-form-input id="basicInput" v-model="musteriUlke" />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" xl="6" class="mb-1">
              <b-row>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group label="İl/İlçe" label-for="basicInput">
                    <b-row>
                      <b-col style="padding-right: 0px"
                        ><b-form-input id="basicInput" v-model="musteriIl"
                      /></b-col>
                      <b-col style="padding-left: 0px"
                        ><b-form-input id="basicInput" v-model="musteriIlce"
                      /></b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group
                    label="Vergi Dairesi/Vergi No"
                    label-for="basicInput"
                  >
                    <b-row>
                      <b-col style="padding-right: 0px"
                        ><b-form-input
                          id="basicInput"
                          v-model="musteriVergiDairesi"
                      /></b-col>
                      <b-col style="padding-left: 0px"
                        ><b-form-input id="basicInput" v-model="musteriVergiNo"
                      /></b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group label="Açıklama" label-for="basicInput">
                    <vs-textarea v-model="musteriAciklama" />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button
                style="border-radius: 5px; background-color: #0d6efd !important"
                type="gradient"
                color="success"
                icon="save"
                @click="musteriAddOnayla()"
                >Kaydet</vs-button
              >
            </vs-row>
          </div>
        </vs-card>
        <vs-card v-else>
          <b-row>
            <b-col sm="12" xl="6" class="mb-1">
              <b-row>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group label="Müşteri Ad/Soyad" label-for="basicInput">
                    <b-row>
                      <b-col style="padding-right: 0px">
                        <b-form-input
                          disabled
                          id="basicInput"
                          v-model="musteriAdSoyad"
                        />
                      </b-col>
                      <b-col style="padding-left: 0px">
                        <b-form-input
                          disabled
                          id="basicInput"
                          v-model="musteriSoyad"
                        />
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group label="Telefon/GSM" label-for="basicInput">
                    <b-row>
                      <b-col style="padding-right: 0px"
                        ><b-form-input
                          id="basicInput"
                          disabled
                          v-model="musteriTelefon"
                      /></b-col>
                      <b-col style="padding-left: 0px"
                        ><b-form-input
                          id="basicInput"
                          disabled
                          v-model="musteriGSM"
                      /></b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group label="E-Mail" label-for="basicInput">
                    <b-form-input
                      id="basicInput"
                      disabled
                      v-model="musteriMail"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group label="Adres" label-for="basicInput">
                    <b-form-input
                      id="basicInput"
                      disabled
                      v-model="musteriAdres"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group label="Ülke" label-for="basicInput">
                    <b-form-input
                      id="basicInput"
                      disabled
                      v-model="musteriUlke"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" xl="6" class="mb-1">
              <b-row>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group label="İl/İlçe" label-for="basicInput">
                    <b-row>
                      <b-col style="padding-right: 0px"
                        ><b-form-input
                          id="basicInput"
                          disabled
                          v-model="musteriIl"
                      /></b-col>
                      <b-col style="padding-left: 0px"
                        ><b-form-input
                          id="basicInput"
                          disabled
                          v-model="musteriIlce"
                      /></b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group
                    label="Vergi Dairesi/Vergi No"
                    label-for="basicInput"
                  >
                    <b-row>
                      <b-col style="padding-right: 0px"
                        ><b-form-input
                          disabled
                          id="basicInput"
                          v-model="musteriVergiDairesi"
                      /></b-col>
                      <b-col style="padding-left: 0px"
                        ><b-form-input
                          disabled
                          id="basicInput"
                          v-model="musteriVergiNo"
                      /></b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mb-1" style="padding-top: 8px">
                  <!-- basic -->
                  <b-form-group label="Açıklama" label-for="basicInput">
                    <vs-textarea disabled v-model="musteriAciklama" />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </vs-card>
      </b-col>
      <b-col cols="3" v-if="museriDetayValidate == false">
        <vs-card>
          <b-row style="padding: 10px">
            <vs-button
              @click="kisiEkle()"
              line-origin="left"
              color="primary"
              type="gradient"
              style="border-radius: 5px"
              icon="group_add"
              >İlgili Kişi Ekle</vs-button
            >
          </b-row>
          <b-row style="padding: 10px">
            <vs-button
              @click="gorusmeKaydiOlustur()"
              line-origin="left"
              color="success"
              type="gradient"
              style="border-radius: 5px"
              icon="call"
              >Görüşme Kaydı Oluştur</vs-button
            >
          </b-row>
          <b-row style="padding: 10px">
            <vs-button
              @click="aktiviteOlustur()"
              line-origin="left"
              color="danger"
              type="gradient"
              style="border-radius: 5px"
              icon="description"
              >Aktivite Oluştur</vs-button
            >
          </b-row>
          <b-row style="padding: 10px">
            <vs-button
              @click="ekstre()"
              line-origin="left"
              color="warning"
              type="gradient"
              style="border-radius: 5px"
              icon="zoom_in"
              >Ekstre</vs-button
            >
          </b-row>
          <b-row style="padding: 10px">
            <vs-button
              @click="resimEkle()"
              line-origin="left"
              color="#02a66d"
              gradient-color-secondary="rgb(1, 52, 74)"
              type="gradient"
              style="border-radius: 5px"
              icon="image"
              >Resim Ekle</vs-button
            >
          </b-row>
        </vs-card>
      </b-col>
    </b-row>
    <b-row v-if="museriDetayValidate == false">
      <vs-card>
        <b-row align-v="center">
          <b-col lg="12" sm="12" style="padding-right: 20px">
            <b-row align-h="center">
              <b-col cols="12" md="auto">
                <vs-button
                  v-on:click="ilgiliKisilerListele()"
                  color="primary"
                  line-origin="left"
                  type="line"
                  style="font-weight: bold; border-radius: 5px"
                  >İlgili Kişiler</vs-button
                >
              </b-col>
              <b-col cols="12" md="auto"
                ><vs-button
                  v-on:click="gorusmeKayitleriListele()"
                  color="success"
                  line-origin="left"
                  type="line"
                  style="font-weight: bold; border-radius: 5px"
                  >Görüşme Kayıtları</vs-button
                >
              </b-col>

              <b-col cols="12" md="auto">
                <vs-button
                  v-on:click="aktivitelerListele()"
                  line-origin="left"
                  color="danger"
                  type="line"
                  style="font-weight: bold; border-radius: 5px"
                  >Aktiviteler</vs-button
                >
              </b-col>
              <b-col cols="12" md="auto">
                <vs-button
                  v-on:click="resimlerListele()"
                  line-origin="left"
                  color="warning"
                  type="line"
                  style="font-weight: bold; border-radius: 5px"
                  >Resimler</vs-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </vs-card>
      <vs-card style="min-height: 450px">
        <div v-if="tableValidate == 'İlgili Kişiler'">
          <ag-grid-vue
            style="width: 100%; height: 500px; margin-top: 10px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="ilgiliKisilerColumn"
            :rowData="ilgiliKisilerRowData"
            :localeText="localeText"
            @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered"
          >
          </ag-grid-vue>
        </div>
        <div v-if="tableValidate == 'Görüşme Kayıtları'">
          <ag-grid-vue
            style="width: 100%; height: 500px; margin-top: 10px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="gorusmelerColumn"
            :rowData="gorusmelerRowData"
            :localeText="localeText"
            @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered"
          >
          </ag-grid-vue>
        </div>
        <div v-if="tableValidate == 'Aktiviteler'">
          <ag-grid-vue
            style="width: 100%; height: 500px; margin-top: 10px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="aktivitelerColumn"
            :rowData="aktivitelerRowData"
            :localeText="localeText"
            @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered"
          >
          </ag-grid-vue>
        </div>
        <div v-if="tableValidate == 'Resimler'">
          <b-row>
            <b-col
              lg="3"
              sm="6"
              :key="index"
              v-for="(item, index) in resimListesi"
            >
              <vs-card>
                <img
                  style="width: 100%"
                  v-bind:src="bindimage + item.URL"
                  class="grid-view-img px-4"
                />
              </vs-card>
            </b-col>
          </b-row>
        </div>
      </vs-card>
    </b-row>

    <b-modal
      ref="modal-kisiekle"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="İlgili Kişi Ekle"
      size="lg"
    >
      <div>
        <b-row>
          <b-col>
            <vs-card>
              <b-form @submit.prevent>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="İlgili Kişi Ad"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="ilgiliKisiAd" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="İlgili Kişi Soyad"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="ilgiliKisiSoyad" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="İlgili Kişi Ünvan"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="ilgiliKisiUnvan" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="İlgili Kişi Telefon"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input
                      id="h-first-name"
                      v-model="ilgiliKisiTelefon"
                    />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="İlgili Kişi Cep Telefonu"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input
                      id="h-first-name"
                      v-model="ilgiliKisiCepTelefon"
                    />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="E-Mail"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="ilgiliKisiEmail" />
                  </b-col>
                </b-row>
              </b-form>
            </vs-card>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <vs-button
            class="float-right"
            @click="cancel()"
            line-origin="left"
            color="danger"
            type="gradient"
            style="border-radius: 5px"
            icon="close"
            >İptal</vs-button
          >
          <vs-button
            class="float-right"
            @click="ilgiliKisiKaydet()"
            line-origin="left"
            color="primary"
            type="gradient"
            style="border-radius: 5px"
            icon="done"
            >İlgili Kişiyi Kaydet</vs-button
          >
        </div>
      </template>
    </b-modal>
    <b-modal
      ref="modal-gorusme"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Görüşme Kaydı Ekle"
      size="lg"
    >
      <div>
        <b-row>
          <b-col>
            <vs-card>
              <b-form @submit.prevent>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Görüşme Tipi"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <v-select
                      color="danger"
                      v-model="gorusmeTipi"
                      :options="gorusmeTipleri"
                      label="name"
                      autocomplete
                      ref="selectElement"
                    >
                    </v-select>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Görüşülen Kişi"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="gorusulenKisi" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Müşteri Notları"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="musteriNotlari" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Açıklama"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input
                      id="h-first-name"
                      v-model="gorusulenAciklama"
                    />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Personel Notu"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="personelNotu" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Görüşme Tarihi"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-datepicker
                      bottom
                      v-model="gorusmeTarihi"
                      size="md"
                      today-variant="danger"
                      :start-weekday="weekday"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric'
                      }"
                    />
                  </b-col>
                </b-row>
              </b-form>
            </vs-card>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <vs-button
            class="float-right"
            @click="cancel()"
            line-origin="left"
            color="danger"
            type="gradient"
            style="border-radius: 5px"
            icon="close"
            >İptal</vs-button
          >
          <vs-button
            class="float-right"
            @click="gorusmeKaydet()"
            line-origin="left"
            color="primary"
            type="gradient"
            style="border-radius: 5px"
            icon="done"
            >Görüşmeyi Kaydet</vs-button
          >
        </div>
      </template>
    </b-modal>
    <b-modal
      ref="modal-aktivite"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Aktivite Ekle"
      size="lg"
    >
      <div>
        <b-row>
          <b-col>
            <vs-card>
              <b-form @submit.prevent>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Alıcı"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <v-select
                      color="danger"
                      v-model="aktiviteAlici"
                      :options="personelOptions"
                      label="EMPLOYEENAME"
                      autocomplete
                      ref="selectElement"
                    >
                    </v-select>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Aktivite Tipi"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <v-select
                      color="danger"
                      v-model="aktiviteTipi"
                      :options="gorusmeTipleri"
                      label="name"
                      autocomplete
                      ref="selectElement"
                    >
                    </v-select>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Aktivite Durumu"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <v-select
                      color="danger"
                      v-model="aktiviteDurumu"
                      :options="durumOptions"
                      label="name"
                      autocomplete
                      ref="selectElement"
                    >
                    </v-select>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Aktivite Notu"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="aktiviteNotu" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Tarih/Saat"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-row>
                      <b-col>
                        <b-form-datepicker
                          bottom
                          v-model="aktiviteTarihi"
                          size="md"
                          today-variant="danger"
                          :start-weekday="weekday"
                          :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric'
                          }"
                        />
                      </b-col>
                      <b-col
                        ><b-form-timepicker v-model="aktiviteSaati"
                      /></b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-form>
            </vs-card>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <vs-button
            class="float-right"
            @click="cancel()"
            line-origin="left"
            color="danger"
            type="gradient"
            style="border-radius: 5px"
            icon="close"
            >İptal</vs-button
          >
          <vs-button
            class="float-right"
            @click="aktiviteKaydet()"
            line-origin="left"
            color="primary"
            type="gradient"
            style="border-radius: 5px"
            icon="done"
            >Aktiviteyi Kaydet</vs-button
          >
        </div>
      </template>
    </b-modal>
    <vs-prompt
      title="Görüşme Resim Ekle"
      acceptText="Ekle"
      cancelText="Vazgeç"
      @accept="resimEkleOnay"
      :active.sync="activePrompt"
    >
      <div class="con-exemple-prompt">
        <b-row style="margin-top: 20px">
          <span>Resim Ekle</span>
          <vs-divider color="Default"> </vs-divider>
          <div class="centerx">
            <!--  <vs-upload
              style="padding: 0"
              automatic
              action="https://jsonplaceholder.typicode.com/posts/"
              @change="onFileChange"
            />-->
            <v-select
              color="danger"
              v-model="gorusmeResimSelected"
              :options="gorusmeResimOptions"
              label="ZIYARET"
              autocomplete
            >
            </v-select>
            <vs-divider color="Default"> </vs-divider>
            <input
              type="file"
              accept="image/*"
              @change="onFileChange"
              id="file-input"
            />
          </div>
        </b-row>
      </div>
    </vs-prompt>
    <CariEkstreComponent ref="cariekstreref" />
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import vSelect from "vue-select";
import { BFormTimepicker, BFormDatepicker } from "bootstrap-vue";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import userJson from "../../../public/user.json";
import CariEkstreComponent from "../components/crm-components/finans-components/CariEkstreComponent.vue";
export default {
  data() {
    return {
      weekday: 1,
      gorusmeResimSelected: "",
      gorusmeResimOptions: [],
      bindimage: userJson.stockImage,
      tableValidate: "İlgili Kişiler",
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      ilgiliKisilerColumn: [],
      ilgiliKisilerRowData: [],

      gorusmelerColumn: [],
      gorusmelerRowData: [],

      aktivitelerColumn: [],
      aktivitelerRowData: [],

      resimListesi: [],

      activePrompt: false,
      aktiviteSaati: "",
      aktiviteTarihi: "",
      aktiviteNotu: "",
      aktiviteDurumu: "",
      aktiviteTipi: "",
      aktiviteAlici: "",
      personelOptions: [],
      durumOptions: [
        { value: "2", name: "Aktif" },
        { value: "3", name: "Pasif" }
      ],

      gorusmeTipi: "",
      gorusulenKisi: "",
      musteriNotlari: "",
      gorusulenAciklama: "",
      personelNotu: "",
      gorusmeTarihi: "",
      gorusmeTipleri: [
        { value: "0", name: "Görüşme Tipi Seçiniz" },
        { value: "2530110", name: "Telefon" },
        { value: "2530120", name: "Mektup" },
        { value: "2530130", name: "Faks" },
        { value: "2530140", name: "E-Posta" },
        { value: "2530150", name: "Ziyaret" },
        { value: "2530160", name: "Genel" },
        { value: "2530170", name: "Fuar" },
        { value: "2530180", name: "Seminer" }
      ],

      ilgiliKisiAd: "",
      ilgiliKisiSoyad: "",
      ilgiliKisiUnvan: "",
      ilgiliKisiTelefon: "",
      ilgiliKisiCepTelefon: "",
      ilgiliKisiEmail: "",
      ilgiliKisilerListesi: [],

      musteriAdSoyad: "",
      musteriSoyad: "",
      musteriGSM: "",
      musteriTelefon: "",
      musteriMail: "",
      musteriAdres: "",
      musteriUlke: "",
      musteriIl: "",
      musteriIlce: "",
      musteriVergiDairesi: "",
      musteriVergiNo: "",
      musteriAciklama: "",

      itemList: [],
      museriDetayValidate: false,
      imageFileName: ""
    };
  },
  methods: {
    musteriAddOnayla() {
      var vm = this;
      var vs = this.$vs;
      vm.tableValidate = "Resimler";
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        musteriTur: "Crm",
        musteriAd: vm.musteriAdSoyad,
        musteriSoyad: this.itemList.ACTID,
        musteriTelefon: vm.musteriTelefon,
        musteriGsm: vm.musteriGSM,
        musteriMail: vm.musteriMail,
        musteriAdres: vm.musteriAdres,
        musteriIl: vm.musteriIl,
        musteriILce: vm.musteriIlce,
        musteriUlke: vm.musteriUlke,
        musteriVergiDairesi: vm.musteriVergiDairesi,
        musteriVergiNo: vm.musteriVergiNo,
        musteriAciklama: vm.musteriAciklama
      };
      soap.createClient(url, function(err, client) {
        client.INT_ADD_MUSTERI(args, function(err, result) {
          if (result.INT_ADD_MUSTERIResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_ADD_MUSTERIResult);
            if (vm.veriler.response == "Ok") {
              vs.notify({
                title: "Başarılı",
                text: "Müşteri kaydı başarılı.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
            } else
              vs.notify({
                title: "Hata",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
          } catch (error) {
            vs.notify({
              title: "Hata",
              text: "Müşteri kaydı sırasında hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    resimlerListele() {
      var vm = this;
      vm.tableValidate = "Resimler";
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        ACTID: this.itemList.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_RESIMLER(args, function(err, result) {
          if (result.INT_RESIMLERResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_RESIMLERResult);

            var list = JSON.parse(vm.veriler.jsonData);
            console.log(list);
            vm.resimListesi = list;
          } catch (error) {}
        });
      });
    },

    aktivitelerListele() {
      var vm = this;
      vm.tableValidate = "Aktiviteler";
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        ACTID: this.itemList.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_AKTIVITELER(args, function(err, result) {
          if (result.INT_AKTIVITELERResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_AKTIVITELERResult);

            var list = JSON.parse(vm.veriler.jsonData);
            console.log(list);
            vm.aktivitelerRowData = list;
          } catch (error) {}
        });
      });
    },
    gorusmeKayitleriListele() {
      var vm = this;
      vm.tableValidate = "Görüşme Kayıtları";
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        ACTID: this.itemList.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_GORUSME_KAYITLARI(args, function(err, result) {
          if (result.INT_GORUSME_KAYITLARIResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_GORUSME_KAYITLARIResult);
            var list = JSON.parse(vm.veriler.jsonData);
            vm.gorusmelerRowData = list;
            console.log(list);
          } catch (error) {}
        });
      });
    },
    ilgiliKisilerListele() {
      var vm = this;
      vm.tableValidate = "İlgili Kişiler";
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        ACTID: this.itemList.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_ILGILI_KISILER(args, function(err, result) {
          if (result.INT_ILGILI_KISILERResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_ILGILI_KISILERResult);
            var list = JSON.parse(vm.veriler.jsonData);
            vm.ilgiliKisilerRowData = list;
          } catch (error) {}
        });
      });
    },
    resimEkleOnay() {
      // gorusmeResimOptions.

      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.imageFileName == "") {
        vs.notify({
          title: "Uyarı",
          text: "Dosya seçimi yapmadınız.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else if (vm.gorusmeResimSelected == "") {
        vs.notify({
          title: "Uyarı",
          text: "Dosya seçimi yapmadınız.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        var args = {
          token: Store.state.tokenId,
          ACTID: this.itemList.ACTID,
          ZIYARET: vm.gorusmeResimSelected.ZIYARET,
          ACTEVENTSID: vm.gorusmeResimSelected.ACTEVENTSID,
          fileName: vm.imageFileName
        };
        soap.createClient(url, function(err, client) {
          client.INT_INS_GORUSME_RESIMLERI(args, function(err, result) {
            if (result.INT_INS_GORUSME_RESIMLERIResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_INS_GORUSME_RESIMLERIResult);
              if (vm.veriler.response == "Ok") {
                vs.notify({
                  title: "Başarılı",
                  text: "Resim kaydı başarılı.",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
              }
            } catch (error) {}
          });
        });
      }
    },
    resimEkle() {
      this.activePrompt = true;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        ACTID: this.itemList.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_GORUSME_RESIMLERI(args, function(err, result) {
          if (result.INT_GORUSME_RESIMLERIResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_GORUSME_RESIMLERIResult);
            var list = JSON.parse(vm.veriler.jsonData);
            vm.gorusmeResimOptions = list;
            console.log(list);
          } catch (error) {}
        });
      });
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = e => {
        vm.image = e.target.result;
        vm.imageFileName = file.name;

        vm.upload(e.target.result, file.name);
      };
      reader.readAsDataURL(file);
    },
    upload(f, fileName) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "upload");
      var letters = {
        İ: "I",
        I: "I",
        Ş: "S",
        Ğ: "G",
        Ü: "U",
        Ö: "O",
        Ç: "C",
        ı: "i",
        ş: "s",
        ğ: "g",
        ü: "u",
        ö: "o",
        ç: "c"
      };
      var args = {
        f: f,
        stokKodu: gelen, // this.pictureBarcode,
        barkod: "",
        fileName: fileName.replace(/(([İIŞĞÜÇÖışğüöç]))/g, function(letter) {
          return letters[letter];
        })
      };

      soap.createClient(url, function(err, client) {
        client.uploadFileGorusme(args, function(err, result) {
          if (this.varyantlimi == "true") {
            //  this.varyantliStokList();
          } else {
            //  this.stockListGet();
          }
        });
      });
    },
    ekstre() {
      this.$refs.cariekstreref.cariEkstre(
        this.itemList.ACTID,
        this.itemList.ACTNAME
      );
    },
    aktiviteOlustur() {
      this.getPersonelList();
      this.$refs["modal-aktivite"].show();
    },
    getPersonelList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId
      };
      soap.createClient(url, function(err, client) {
        client.INT_PERSONELLER(args, function(err, result) {
          if (result.INT_PERSONELLERResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_PERSONELLERResult);
            console.log(vm.veriler);

            vm.personelOptions = JSON.parse(vm.veriler.jsonData);
            console.log(vm.veriler);
          } catch (error) {}
        });
      });
    },
    aktiviteKaydet() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      console.log(vm.aktiviteAlici);
      if (vm.aktiviteAlici == "") {
        vs.notify({
          title: "Uyarı",
          text: "Alıcı değeri girmediniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        var args = {
          token: Store.state.tokenId,
          aktiviteAlici: vm.aktiviteAlici.EMPLOYEEID,
          aktiviteNotu: vm.aktiviteNotu,
          aktiviteTipi: vm.aktiviteTipi.value,
          aktiviteDurumu: vm.aktiviteDurumu.value,
          aktiviteTarihi: vm.aktiviteTarihi,
          aktiviteSaati: vm.aktiviteSaati,
          userId: Store.state.UserId,
          ACTID: this.itemList.ACTID
        };
        soap.createClient(url, function(err, client) {
          client.INT_INS_AKTIVITE(args, function(err, result) {
            if (result.IINT_INS_AKTIVITEResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_INS_AKTIVITEResult);
              console.log(vm.veriler);
              if (vm.veriler.response == "Ok") {
                vs.notify({
                  title: "Başarılı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
                vm.aktiviteSaati = "";
                vm.aktiviteTarihi = "";
                vm.aktiviteNotu = "";
                vm.aktiviteDurumu = "";
                vm.aktiviteTipi = "";
                vm.aktiviteAlici = "";
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
              }
            } catch (error) {}
          });
        });
      }
    },
    gorusmeKaydet() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.gorusmeTipi == "") {
        vs.notify({
          title: "Uyarı",
          text: "Görüşme tipi girmediniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        var args = {
          token: Store.state.tokenId,
          gorusmeTipi: vm.gorusmeTipi.name,
          gorusmeTarihi: vm.gorusmeTarihi,
          gorusulenKisi: vm.gorusulenKisi,
          personelNotu: vm.personelNotu,
          musteriNotu: vm.musteriNotlari,
          userId: Store.state.UserId,
          ACTID: this.itemList.ACTID
        };
        soap.createClient(url, function(err, client) {
          client.INT_INS_GORUSME(args, function(err, result) {
            if (result.INT_INS_GORUSMEResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_INS_GORUSMEResult);
              console.log(vm.veriler);
              if (vm.veriler.response == "Ok") {
                vs.notify({
                  title: "Başarılı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
                vm.gorusmeTipi = "";
                vm.gorusulenKisi = "";
                vm.musteriNotlari = "";
                vm.gorusulenAciklama = "";
                vm.personelNotu = "";
                vm.gorusmeTarihi = "";
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
              }
            } catch (error) {}
          });
        });
      }
    },
    ilgiliKisiKaydet() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;

      var args = {
        token: Store.state.tokenId,
        ilgiliKisiAd: vm.ilgiliKisiAd,
        ilgiliKisiSoyad: vm.ilgiliKisiSoyad,
        ilgiliKisiUnvan: vm.ilgiliKisiUnvan,
        ilgiliKisiTelefon: vm.ilgiliKisiTelefon,
        ilgiliKisiCepTelefon: vm.ilgiliKisiCepTelefon,
        ilgiliKisiEmail: vm.ilgiliKisiEmail,
        userId: Store.state.UserId,
        ACTID: this.itemList.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_INS_ILGILI_KISI(args, function(err, result) {
          if (result.INT_INS_ILGILI_KISIResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_INS_ILGILI_KISIResult);
            console.log(vm.veriler);
            if (vm.veriler.response == "Ok") {
              vs.notify({
                title: "Başarılı",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
              vm.ilgiliKisiAd = "";
              vm.ilgiliKisiSoyad = "";
              vm.ilgiliKisiUnvan = "";
              vm.ilgiliKisiTelefon = "";
              vm.ilgiliKisiCepTelefon = "";
              vm.ilgiliKisiEmail = "";
            } else {
              vs.notify({
                title: "Uyarı",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            }
          } catch (error) {}
        });
      });
    },
    cancel() {
      this.$refs["modal-kisiekle"].hide();
      this.ilgiliKisiAd = "";
      this.ilgiliKisiSoyad = "";
      this.ilgiliKisiUnvan = "";
      this.ilgiliKisiTelefon = "";
      this.ilgiliKisiCepTelefon = "";
      this.ilgiliKisiEmail = "";

      this.gorusmeTipi = "";
      this.gorusulenKisi = "";
      this.musteriNotlari = "";
      this.gorusulenAciklama = "";
      this.personelNotu = "";
      this.gorusmeTarihi = "";

      this.aktiviteSaati = "";
      this.aktiviteTarihi = "";
      this.aktiviteNotu = "";
      this.aktiviteDurumu = "";
      this.aktiviteTipi = "";
      this.aktiviteAlici = "";
    },
    gorusmeKaydiOlustur() {
      this.$refs["modal-gorusme"].show();
    },
    kisiEkle() {
      this.$refs["modal-kisiekle"].show();
    },
    musteriDetay() {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        Tur: this.itemList.CariDurum,
        ACTID: this.itemList.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_MUSTERI_DETAY(args, function(err, result) {
          if (result.INT_MUSTERI_DETAYResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_MUSTERI_DETAYResult);

            if (vm.veriler.response == "Ok") {
              var list = JSON.parse(vm.veriler.jsonData);
              console.log(list);
              vm.musteriAdSoyad = list[0].FIRSTNAME;
              vm.musteriSoyad = list[0].LASTNAME;
              vm.musteriGSM = list[0].PHONE1;
              vm.musteriTelefon = list[0].GSM;
              vm.musteriMail = list[0].EMAIL;
              vm.musteriAdres = list[0].ADDRESS1;
              vm.musteriUlke = list[0].COUNTRY;
              vm.musteriIl = list[0].CITY;
              vm.musteriIlce = list[0].TOWN;
              vm.musteriVergiDairesi = list[0].TAXOFFICE;
              vm.musteriVergiNo = list[0].TAXNO;
              vm.musteriAciklama = list[0].NOTES;
            } else {
              vs.notify({
                title: "Uyarı",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            }
          } catch (error) {
            vs.notify({
              title: "Hata",
              text: "Liste getirilirken hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    }
  },
  components: {
    "v-select": vSelect,
    BFormTimepicker,
    BFormDatepicker,
    CariEkstreComponent,
    AgGridVue
  },
  created() {
    if (this.$route.params.item == "Crm") {
      this.museriDetayValidate = true;
    } else {
      this.itemList = this.$route.params.item;
      console.log(this.itemList);
      this.musteriDetay();
      this.ilgiliKisilerListele();
      if (this.itemList.length < 0) this.museriDetayValidate = true;
    }
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },

  beforeMount() {
    this.ilgiliKisilerColumn = [
      {
        headerName: "Ad",
        field: "NAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Soyad",
        sortable: true,
        filter: "agDateColumnFilter",
        field: "SURNAME",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Ünvan",
        field: "MISSION",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "E-Mail",
        field: "EMAIL",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Telefon",
        field: "PHONE1",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "GSM",
        field: "PHONE3",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
    this.gorusmelerColumn = [
      {
        headerName: "Tarih",
        field: "TRANSDATE",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Görüşme Tarihi",
        sortable: true,
        filter: "agDateColumnFilter",
        field: "EVENTDATE",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Tür",
        field: "EVENT",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Görüşülen Kullanıcı",
        field: "EMPLOYEENAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Görüşülen Kişi",
        field: "DESCRIPTION1",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Personel Notu",
        field: "DESCRIPTION2",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Müşteri Notu",
        field: "DESCRIPTION3",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
    this.aktivitelerColumn = [
      {
        headerName: "Aktivite Oluşturan",
        field: "EMPLOYEENAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Alıcı",
        sortable: true,
        filter: "agDateColumnFilter",
        field: "ALICI",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Görüşülecek Müşteri",
        field: "CRMCONTACTSFULLNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Aktivite Notu",
        field: "NOTES",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Aktivite Tipi",
        field: "ACTIVITYTYPENAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Aktivite Durumu",
        field: "STATUSNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
  }
};
</script>
<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}
[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}
[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}
.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}
[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}
[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}
.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
</style>
